import { TableHead, TableHeader, TableRow } from '@/components/ui';

const DataTableHeader = () => (
	<TableHeader>
		<TableRow>
			<TableHead className="w-[160px]">Produits</TableHead>
			<TableHead className="w-[80px]">Bonus</TableHead>
			<TableHead className="w-[120px]">Du</TableHead>
			<TableHead className="w-[120px]">Au</TableHead>
			<TableHead className="w-[110px]">Statut</TableHead>
			<TableHead className="w-[100px] text-right">Actions</TableHead>
		</TableRow>
	</TableHeader>
);

export default DataTableHeader;
